/**
 * @generated SignedSource<<9f0da4dc96671acf74c712965b6db467>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EmployeeSelectControllerComponent_Store$data = {
  readonly employees: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
        readonly " $fragmentSpreads": FragmentRefs<"Avatar_employee" | "EmployeeSelectControllerListItem_employee">;
      };
    }>;
  };
  readonly id: string;
  readonly " $fragmentType": "EmployeeSelectControllerComponent_Store";
};
export type EmployeeSelectControllerComponent_Store$key = {
  readonly " $data"?: EmployeeSelectControllerComponent_Store$data;
  readonly " $fragmentSpreads": FragmentRefs<"EmployeeSelectControllerComponent_Store">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "autoOrderEmployeeIds"
    },
    {
      "kind": "RootArgument",
      "name": "autoOrderTeamId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployeeSelectControllerComponent_Store",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "autoOrderEmployeeIds",
          "variableName": "autoOrderEmployeeIds"
        },
        {
          "kind": "Variable",
          "name": "autoOrderTeamId",
          "variableName": "autoOrderTeamId"
        },
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": "AUTO"
        }
      ],
      "concreteType": "EmployeeConnection",
      "kind": "LinkedField",
      "name": "employees",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EmployeeConnectionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Employee",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "Avatar_employee"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "EmployeeSelectControllerListItem_employee"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Store",
  "abstractKey": null
};
})();

(node as any).hash = "0d12ea9179b12630045ef58df4cc7cbb";

export default node;
